export default __webpack_public_path__ + "static/media/ic_busd_24.2432ce58.svg";